module.exports = __webpack_public_path__ + "static/media/bicc_center_left.2db6de44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/apps/BCOMS/resources/bicc_center_left.jpg
// module id = 1113
// module chunks = 0